import Vue from "vue";

Vue.mixin({
  methods: {
    slideText(step) {
        const modalText = document.querySelector(".modal-text-1");
        let textArray = [];

        switch (step) {
          case 1:
            textArray = [
              "Wysłaliśmy Twoje zapytanie do Towarzystw Ubezpieczeniowych ",
              "Zbieramy dostępne oferty ubezpieczenia",
              "Sprawdzamy i wybieramy najlepsze oferty dla Ciebie",
            ];
            break;
          case 3:
            textArray = [
              "Gratulujemy podjęcia dobrej decyzji!",
              "Odpręż się, Twój wniosek jest przetwarzany przez Towarzystwo",
              "Przygotuj się do płatności online, za chwilę nastąpi przekierowanie",
            ];
            break;
        }
        modalText.innerHTML = textArray[0];
        for (let index = 1; index < 3; index++) {
          setTimeout(function () {
            modalText.style.opacity = "0";
          }, index * 4000);

          setTimeout(function () {
            modalText.innerHTML = textArray[index];
            modalText.style.opacity = "1";
          }, index * 4500);
        }
    },
  },
});
